import { render, staticRenderFns } from "./WRStatus.vue?vue&type=template&id=bab1de88&scoped=true&"
import script from "./WRStatus.vue?vue&type=script&lang=js&"
export * from "./WRStatus.vue?vue&type=script&lang=js&"
import style0 from "./WRStatus.vue?vue&type=style&index=0&id=bab1de88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bab1de88",
  null
  
)

export default component.exports